import { createTheme } from '@mui/material'

const moduleColor = '#4B6687'

export const rightsTheme = createTheme({
    palette: {
        primary: {
            main: moduleColor
        }
    },
    components: {
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    fontSize: '0.85rem'
                },
                root: {
                    marginRight: '0',
                    marginBottom: '0'
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                sizeMedium: {
                    padding: '0.5rem'
                },
                head: {
                    paddingLeft: 0,
                    borderBottom: 'none'
                }
            }
        },
        MuiRadio: {
            styleOverrides: {
                colorPrimary: {
                    color: moduleColor
                }
            }
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: moduleColor
                }
            }
        }
    }
})
